export default "__VITE_ASSET__Dr4EiWd3__"